import UserJoinButton from "components/join/UserJoinButton";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import LogoutLink from "../parts/LogoutLink";
import MobileSubscriptionModal from "./MobileSubscriptionModal";
import MobileUserNavSidepanel from "./MobileUserNavSidepanel";
import ShareButton from "./ShareButton/ShareButton";

export default function MobileNavLinks() {
  const {
    isLoggedIn,
    isOnboarded,
    pro
  } = useCurrentUser((u) => {
    return {
      isOnboarded: u?.onboarded || false,
      pro: u?.pro || false,
      isLoggedIn: u?.id > 0,
    };
  });

  return (
    <div className="lg:hidden flex space-x-4 justify-end items-center pr-1">
      <ShareButton />
      {!isLoggedIn ? (
        <>
          <UserJoinButton variant="primary" tab="Login">
            <>Login</>
          </UserJoinButton>
        </>
      ) : (
        <>
          {isOnboarded ? (
            <>
              {!pro && <MobileSubscriptionModal />}
              <MobileUserNavSidepanel />
            </>
          ) : (
            <LogoutLink />
          )}
        </>
      )}
    </div>
  );
}
